import { BookLink } from './BookLink'
import { withBookLink } from './withBookLink'

const ConnectedBookLink = withBookLink(BookLink)

export { ConnectedBookLink as BookLink }
